import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { ErrorService } from '@core/services';

@Component({
  selector: 'z-notifications',
  templateUrl: './notifications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<boolean>();

  display: boolean = false;

  title$ = new BehaviorSubject<string>(null);
  icon$ = new BehaviorSubject<string>(null);
  message$ = new BehaviorSubject<string>(null);
  type$ = new BehaviorSubject<string>(null);
  timestamp$ = new BehaviorSubject<Date>(null);
  url$ = new BehaviorSubject<string>(null);
  statusCode$ = new BehaviorSubject<number>(null);
  requestId$ = new BehaviorSubject<string>(null);
  errorCode$ = new BehaviorSubject<string>(null);

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private errorService: ErrorService, private translocoService: TranslocoService) {}

  ngOnInit() {
    this.errorService.display$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.display = state;
    });

    this.errorService.payload$
      .pipe(
        filter((payload) => !!payload),
        takeUntil(this.destroy$)
      )
      .subscribe((payload) => {
        this.title$.next(payload.title);
        this.icon$.next(payload.icon);
        this.type$.next(payload.type);
        this.timestamp$.next(payload.timestamp);

        if (payload.type === 'validation') {
          this.message$.next(`${this.translate('core.components.notifications.labels.validation_error')}: ${payload.message as string}`);
        } else {
          this.message$.next(payload.message);
        }

        if (payload.request) {
          this.url$.next(payload.request.url);
          this.statusCode$.next(payload.request.statusCode);
          this.requestId$.next(payload.request.requestId);
          this.errorCode$.next(payload.request.errorCode);
        } else {
          this.url$.next(null);
          this.statusCode$.next(null);
          this.requestId$.next(null);
          this.errorCode$.next(null);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  closeErrorDialog() {
    this.errorService.dismissError();
  }
}
